import {API_REQUEST} from "Request/API";
import {SOURCE_ID_MAP} from "./handleCardRequest";

export const handleAddBankCardRequest = async (
    toast: any,
    isPrimary: boolean = false,
    paymentMethod: any
) =>
    await API_REQUEST("POST", "medical/manage-subscription", {
      sourceId: SOURCE_ID_MAP[paymentMethod?.method],
      cardId: null,
      // isPrimary: isPrimary,
    })
        .then((res) => (document.location = res?.redirectUrl))
        .catch(() =>
            toast("მოხდა შეცდომა, თავიდან სცადეთ", {
              type: "error",
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              draggable: true,
              theme: "light",
            })
        );
